import attributionPostbacksImageSrc from '../resources/png/teamManagement/attribution_postbacks.png';
import attributionWindowSettingsImageSrc from '../resources/png/teamManagement/attribution_window_settings.png';
import configurationCredentialsImageSrc from '../resources/png/teamManagement/configuration_credentials.png';
import eventPostbacksImageSrc from '../resources/png/teamManagement/event_postbacks.png';
import linkAttributionSettingsImageSrc from '../resources/png/teamManagement/link_attribution_settings.png';
import linkOgTagsImageSrc from '../resources/png/teamManagement/link_og_tags.png';
import linkParametersImageSrc from '../resources/png/teamManagement/link_parameters.png';
import linkSettingsAndRedirectsImageSrc from '../resources/png/teamManagement/link_settings_and_redirects.png';
import { SECTIONS_PAGES_CONFIG as BASE_SECTIONS_PAGES_CONFIG } from '../utils/sectionsConfig';

// Layers the tooltip images (and their preload) onto the PNG-free config from ../utils/sectionsConfig.
const TOOLTIP_IMAGE_SRCS = {
    configuration_credentials: configurationCredentialsImageSrc,
    attribution_postbacks: attributionPostbacksImageSrc,
    attribution_window_settings: attributionWindowSettingsImageSrc,
    event_postbacks: eventPostbacksImageSrc,
    link_settings_and_redirects: linkSettingsAndRedirectsImageSrc,
    link_attribution_settings: linkAttributionSettingsImageSrc,
    link_og_tags: linkOgTagsImageSrc,
    link_parameters: linkParametersImageSrc,
};

// Preload images
Object.values(TOOLTIP_IMAGE_SRCS).forEach(src => {
    const img = new Image();
    img.src = src;
});

export const SECTIONS_PAGES_CONFIG = BASE_SECTIONS_PAGES_CONFIG.map(page => ({
    ...page,
    cards: page.cards.map(card => ({
        ...card,
        parts: card.parts.map(part => ({
            ...part,
            ...(part.tooltipImageKey ? { tooltipImageSrc: TOOLTIP_IMAGE_SRCS[part.tooltipImageKey] } : {}),
        })),
    })),
}));

export {
    SECTION_PAGES_STEPS,
    VIEW_ONLY_PAGES_MAP,
    isScreenViewOnly,
    buildAccessTypesRecord,
    getPartAccessType,
    buildPartDisplayName,
} from '../utils/sectionsConfig';
